import API from "shared/services/Api";
import { ISendSignature } from "shared/types/Signature";

export const sendSignature = async (data: ISendSignature, userId: string) =>
  API.post(`oc/clinicalrecord/signature?id=${userId}`, data);
